import { Injectable } from '@angular/core';
import  * as OAuth  from 'oauth-1.0a';
import * as CryptoJS from 'crypto-js';


@Injectable({
  providedIn: 'root'
})
export class OAuthService {

  private oAuthInstance: OAuth;

  constructor() { }

  createOauthInstance(consumerKey: string, consumerSecret: string): void {
    this.oAuthInstance = new OAuth({
      consumer: {
        key: consumerKey,
        secret: consumerSecret
      },
      signature_method: 'HMAC-SHA1',
      hash_function: function (base_string, key) {
        return CryptoJS.HmacSHA1(base_string, key).toString(
          CryptoJS.enc.Base64
        );
      }
    });
  }

  generateOauthParams(url: string, params: Object): Object {
    return this.oAuthInstance.authorize({
      url,
      method: 'POST',
      data: params
    })
  }
}
